import Patch from "@shared/models/patch-updater"
import createNarrative from "@shared/actions/create-narrative"

export default {
  USER_CHANGE_NAME: {
    name: "USER_CHANGE_NAME",

    params: {
      userId: "string",
      field: "string",
      value: "string",
    },

    patches(payload) {
      // prevent arbitrary field settings
      let field = payload.field === "firstName" ? "firstName" : "lastName"

      let patch = Patch.create("user", payload.userId).set(
        `attributes.${field}`,
        payload.value
      ).patch

      return [patch]
    },
  },
  USER_CHANGE_AVATAR_COLOR: {
    name: "USER_CHANGE_AVATAR_COLOR",

    params: {
      userId: "string",
      value: "string",
    },

    patches(payload) {
      let patch = Patch.create("user", payload.userId).set(
        `attributes.avatarColor`,
        payload.value
      ).patch

      return [patch]
    },
  },

  USER_SET_FLAG: {
    name: "USER_SET_FLAG",

    params: {
      userId: "string",
      field: "string",
      value: "string",
    },

    patches(payload) {
      let patch = Patch.create("user", payload.userId).set(
        `attributes.flags.${payload.field}`,
        payload.value
      ).patch

      return [patch]
    },
  },

  USER_ONBOARDING_UPDATE_ACCOUNT: {
    params: {
      userId: "string",
      salutation: "object",
      firstName: "object",
      lastName: "string",
      educationRole: "string",
      lastOnboardingStep: "number",
    },
    patches(payload) {
      let patch = Patch.create("user", payload.userId)
        .set(`attributes.salutation`, payload.salutation)
        .set(`attributes.firstName`, payload.firstName)
        .set(`attributes.lastName`, payload.lastName)
        .set(`attributes.educationRole`, payload.educationRole)
        .set(`attributes.lastOnboardingStep`, payload.lastOnboardingStep).patch

      return [patch]
    },
  },
}
